module.exports = __webpack_public_path__ + "fonts/interactive.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.eot
// module id = 6
// module chunks = 0